module.exports = __webpack_public_path__ + "static/media/bell.7bbd5ed2.svg";